import { useTranslation } from 'react-i18next';

const RegisteredPage = () => {
  const { t } = useTranslation(['registerpage']);
  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1>{t("registerpage:registeredDescription")}</h1>
    </div>
  );
};

export default RegisteredPage;